import './App.css';
import About from './pages/About';
import Cart from './pages/Cart';
import CheckoutPage from './pages/CheckoutPage';
import ConsumerProduct from './pages/ConsumerProduct';
import Contact from './pages/Contact';
import Home from './pages/Home';
import ProductList from "./pages/ProductList"; // Renamed to start with uppercase
import PerfessionalProduct from './pages/PerfessionalProduct';
import Product from './pages/Product';
import ShoppingCart from './pages/ShoppingCart';
import ProductDetails from './pages/ProductDetails'; // Assuming this is your component for product details

import './style.scss';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Support from './pages/Support';
import News from './pages/News';
import ProductDetail from './pages/ProductDetail';
import SeriesDetail from './components/SeriesDetail';
import Smart from './pages/Smart';
import New from './pages/New';
import Ourproduct from './pages/Ourproduct';


function App() {
  return (
    <>  
    <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/product" element={<Product />} />
          <Route path="/product-detail" element={<ProductDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/consumer-product" element={<ConsumerProduct/>} />
          <Route path="/perfessional-product" element={<PerfessionalProduct/>} />
          <Route path="/cart/:id" element={<Cart/>} />
          <Route path="/shopping-cart" element={<ShoppingCart/>} />
          <Route path="/checkoutpage" element={<CheckoutPage/>} />
          <Route path="/productlist/:id" element={<ProductList/>} />
          <Route path="/product-details/:id" element={<ProductDetails />} />
          <Route path="/support" element={<Support />} />
          <Route path="/news" element={<News />} />
          <Route path="/series/:category/:index" element={<SeriesDetail />} />
          <Route path="/smartlighting" element={<Smart/>} />
          <Route path="/New" element={<New/>} />
          <Route path="/Ourproduct" element={<Ourproduct/>} />

          </Routes>
    </Router>
    </>
  );
}

export default App;
